import React, { useEffect, useState } from "react";
import { Table, Tag, Button, Modal } from "antd";
import { Eye } from "lucide-react";
import WebUtils from "../../../../../utils/WebUtils";
import { getAllBulkDetails } from "../../../../../api/globalAdmin/Index";
import noJob from "../../../../../assets/insight/noJobs.svg";
import { useNavigate } from "react-router-dom";
import Utils from "../../../../../utils/Utils";

const BulkUploadMain = ({ setLoading, selectedBatch }) => {
  const userDetail = Utils.getUserDetail();
  const [bulkData, setBulkData] = useState(null);
  const navigate = useNavigate();

  const getAllBulks = (pageNo, pageSize, searchInput) => {
    const url = `${getAllBulkDetails}?organizationId=${
      userDetail?.organizationId || null
    }&batchIdentifier=${selectedBatch}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBulkData(result?.data?.data || []);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getAllBulks();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "COMPLETED":
        return "success";
      case "IN_PROGRESS":
        return "warning";
      case "FAILED":
        return "error";
      default:
        return "default";
    }
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "COMPLETED":
        return "bg-green-50 text-green-700 border-green-200";
      case "IN_PROGRESS":
        return "bg-yellow-50 text-yellow-700 border-yellow-200";
      case "FAILED":
        return "bg-red-50 text-red-700 border-red-200";
      default:
        return "bg-red-50 text-red-700 border-red-200";
    }
  };

  const handleBulkClick = (record) => {
    navigate(
      `/org-admin/batches/bulk?batchIdentifier=${selectedBatch}&bulkId=${record?.bulkIdentifier}`,
    );
  };

  const columns = [
    {
      title: (
        <span className="text-[#475467] font-medium text-[.85rem]">S. No.</span>
      ),
      dataIndex: "sno",
      key: "sno",
      width: 80,
      render: (_, __, index) => (
        <div className="ml-2 text-[.85rem] text-[#475467]">{index + 1}</div>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.85rem]">
          Bulk Id
        </span>
      ),
      dataIndex: "bulkIdentifier",
      key: "bulkIdentifier",
      width: 230,
      render: (text, record) => (
        <span
          className="text-[#DC6803] cursor-pointer hover:underline font-medium"
          onClick={() => handleBulkClick(record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.85rem]">
          Created On
        </span>
      ),
      dataIndex: "creationDate",
      key: "creationDate",
      width: 180,
      render: (date) => (
        <span className="text-[.85rem] text-[#475467]">
          {new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          })}
        </span>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.85rem]">
          Messages
        </span>
      ),
      dataIndex: "messages",
      key: "messages",
      width: 280,
      render: (text) => (
        <span className="text-gray-600 text-[.85rem]">{text || "—"}</span>
      ),
    },
    {
      title: (
        <span className="text-[#475467] font-medium text-[.85rem]">Status</span>
      ),
      dataIndex: "bulkStatus",
      key: "bulkStatus",
      width: 180,
      align: "center",
      render: (status) => (
        <span
          className={`inline-flex items-center shadow-sm gap-2 rounded-lg border px-3 py-1 text-[.85rem] font-medium ${getStatusClass(
            status,
          )}`}
        >
          <span
            className={`w-1.5 h-1.5 rounded-full ${
              status === "COMPLETED"
                ? "bg-green-600"
                : status === "IN_PROGRESS"
                  ? "bg-yellow-600"
                  : status === "FAILED"
                    ? "bg-red-600"
                    : "bg-red-600"
            }`}
          ></span>
          {status
            ?.toLowerCase()
            .replace("_", " ")
            .replace(/\b\w/g, (char) => char.toUpperCase())}
        </span>
      ),
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   width: 100,
    //   align: "center",
    //   render: (_, record) => (
    //     <Button
    //       type="link"
    //       icon={<Eye size={16} />}
    //       onClick={() => handleBulkClick(record)}
    //       className="!text-[#DC6803] !p-0"
    //     >
    //       View
    //     </Button>
    //   ),
    // },
  ];

  return (
    <>
      {bulkData && bulkData.length > 0 ? (
        <div className="rounded-2xl bg-white shadow-sm mt-1">
          <Table
            columns={columns}
            dataSource={bulkData}
            rowKey="bulkIdentifier"
            // pagination={{
            //   pageSize: 10,
            //   showTotal: (total) => `Total ${total} items`,
            //   showSizeChanger: true,
            //   showQuickJumper: true,
            // }}
            pagination={false}
            scroll={{ x: 1000 }}
          />
        </div>
      ) : (
        <div className="text-center mt-[3rem]">
          <img src={noJob} width={370} className="mx-auto" alt="" />
          <p className="sub-text-color text-[.94rem] mt-3 max-w-[450px] mx-auto">
            No bulk upload data found.
          </p>
        </div>
      )}
    </>
  );
};

export default BulkUploadMain;
